export const setError = (error) => async (dispatch,getState) =>{
    dispatch({
        type:"SET_VALIDATION_ERROR",
        payload:error
    })
}
